import ProfitSharingApp from "./ProfitSharingApp";

function App() {
  return <ProfitSharingApp />;
}

export default App;
